<template>
    <div class="canvas-column" v-if="artwork && order">
        <div class="project-canvas-container">
            <div class="project-canvas-scroll-container">
                <div class="project-canvas">
                    <div class="image-canvas-container">
                        <div class="image-canvas">

                            <div class="image-wrapper fit-horizontally">
                                <div class="image-scroll-container">
                                    <div>
                                        <template v-if="imageLoading">
                                            <div class="spinner-border text-primary" role="status">
                                                <span class="sr-only">Loading...</span>
                                            </div>
                                        </template>
                                        <template v-if="imageLoadFailed">
                                            <div class="alert alert-danger" role="alert">
                                                Failed to load artwork!
                                            </div>
                                        </template>
                                        <div @click="addComment($event)" style="cursor: url(&quot;data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAstJREFUSImtlV2IVVUYhp9vnW1HknGYJPEnCbVgCJrJn3Gg8CJInLwwvdCyggymEO9CC69kEC+UfpggwaBImyjyh0iR8Y+QJCqYLlLBfr2QcJQodZzIM3uv7/Vi5nDOqZk9M6de2LDXXu/3vd/7rb3WMklbgHYmjhJwFfgF6DWzy7lsSQdVP9xd30haOVb+BIgA84sZ6dD45TdMh1lzjeaHYeWaYE+utWXFqRx3V68Zz5vZn9V8k/QxsOGBuzNu/z2+wD8x+z54bWeBdS8Y7lwKgQ4z+7k8HwAHKBQmnxyg/zd4ZWPk1U7HI/PdOS7pnmqBCBBCfQJlfPK+s7UzWggsAHqqBRwg1OmgGoc+FD17HWBVeeEn1aLu/QW2dOVbfWO789cgLtFVFphwi1qWGEsfs1zOH7/DgX0ezGiXNO9/bVEZJz8XgAGrKgL/cZGr8X2fyq8LkrJAkvybuOPtwKJllZY0zRDTGoyjXw/bLSTwwTvOwf2qiRu4AaXbeHEqcxJgAGBagwG1xJvXYXCwMo4RPFa+hQIM3hrdhQ3XVUqAfoBZc+DHC7WkN7u8ZvzFhYRr/WLDijh61hE0NsFdRQJwJQA/AbQszf87JoPWSq6LATgjcatjTVBOzKSwYrUhkQG9wcxKZnzW2oa1L893ce470fdVfh0z7oWnX7RoxjEzu2EAkhZKXDzXp+SpR6NlWf3V73438OxLwc14xMzOBwAz+9WMt1rbzLq6698Q6zcGnns5YMYeMztfMympIOmEJL3XHXV/kmouE3+2dkalqaKkM5KmjFqBpMayyLdnPXYszsZN3DYv1eGPPI5coaclNeXaHHGyy11D7tKXpzzdtinqiZZMrTNTNTemevyhTJufyXTkU8/SIWXuSiW9LmmU82BsoYWS9km6OfaNrwFJPZIeHCvPuLtLUhFYDjQDsxk+T64CPwBnzayUF38H/abEdJrmV6IAAAAASUVORK5CYII=&quot;), copy; width: 100%; height: 100%;">
                                            <template v-if="['png', 'jpg', 'jpeg'].some( image => artwork.attach_link.toLowerCase().includes(image))">
                                                <img v-if="!imageLoadFailed" :src="route('medias.view', {path: 'so_attachments',id: this.order.id,name: artwork.attach_link})" @load="imageLoaded" @error="imageFailed">
                                            </template>
                                            <template v-if="['pdf'].some( pdf => artwork.attach_link.toLowerCase().includes(pdf))">
                                                <img v-if="!imageLoadFailed" :src="route('medias.view', {path: 'so_attachments',id: this.order.id,name: artwork.attach_link, pdf_to_image: true})" @load="imageLoaded" @error="imageFailed">
                                            </template>

                                            <div @click="updateComment($event, item)" v-for="(item, index) in comments" class="markup-thread-pin threadPin" style="transform-origin: center center 0px !important; position: absolute !important;"
                                                 :style="{top: item.offset_y_percentage + 'px !important', left: item.offset_x_percentage + 'px !important'}">
                                                <div class="markup-thread-pin-content markupThreadPinContent">{{item.version_number}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="image-project-click-shield has-pending-thread" v-if="showPostFrm">
                            <div class="canvas-pending-thread-form">
                                <form ref="postFrm" class="form" style="position: absolute;"
                                      :style="{ top: topPosition+'px', left: leftPosition+'px' }">
                                    <div class="form-contents top">
                                        <div class="form-text-and-controls">
                                            <div class="close-button" @click="closePostFrm">✕</div>
                                            <vue-editor v-model="comment.comment" :editorToolbar="getQuillToolbar()"></vue-editor>
                                            <div class="message-form-buttons">
                                                <button class="post-button" @click="save" type="button">Post</button>
                                            </div>

                                        </div>

                                    </div>
                                </form>
                                <div v-if="!isUpdate" class="pin" style="position: absolute;" :style="{ top: topPosition+'px', left: leftPosition+'px' }">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';
import { VueEditor } from "vue2-editor";

export default {
    name: "ArtworkImage",
    components: {
        VuePdfEmbed,
        VueEditor
    },
    props: ['order', 'artwork', 'is_edit', 'bus'],
    created() {

    },
    beforeMount() {

    },
    mounted() {
        let self = this;
        $('#artworkCommentModal').on('hidden.bs.modal', function () {
            self.imageLoading = true;
            self.imageLoadFailed = false;
            self.pdfLoadingFailed = false;
        });
        this.bus.$on('commentDeletedAffect', this.getComments);
    },
    data() {
        return {
            submitted: false,
            showPostFrm: false,
            topPosition: null,
            leftPosition: null,
            isUpdate: false,
            comment: {
                id: null,
                offsetXPercentage: null,
                offsetYPercentage: null,
                containerHeight: null,
                containerWidth: null,
                containerOffsetX: null,
                containerOffsetY: null,
                pinX: null,
                pinY: null,
                comment: null
            },
            comments: [],
            imageLoading: true,
            imageLoadFailed: false,
            pdfLoadingFailed: false

        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        updateComment(event, item) {
            if(!this.is_edit) {
                return;
            }
            this.comment = _.cloneDeep(item);
            //this.leftPosition = Number(item.offset_x_percentage) + 67;
            this.leftPosition = Number(item.offset_x_percentage);
            this.topPosition = Number(item.offset_y_percentage);
            this.showPostFrm = true;
            this.isUpdate = true;
        },
        addComment(event) {
            if(!this.is_edit) {
                return;
            }
            // console.log(event)
            // clientX/Y gives the coordinates relative to the viewport in CSS pixels.
            //console.log(event.clientX);
            //console.log(event.clientY);

            // pageX/Y gives the coordinates relative to the <html> element in CSS pixels.
            //console.log(event.pageX);
            //console.log(event.pageY);

            // screenX/Y gives the coordinates relative to the screen in device pixels.
            //console.log(event.screenX);
            //console.log(event.screenY);

            let bounds = event.target.getBoundingClientRect();
            let x = event.clientX - bounds.left;
            let y = event.clientY - bounds.top;

            //console.log('container', window.innerWidth, window.innerHeight);
            //console.log(' containerOffset', event.offsetX, event.offsetY);
            //console.log('pos', x, y);

            //this.leftPosition = event.layerX;
            //this.topPosition = event.layerY;

            if(event.target.nodeName == 'IMG') {
                //this.leftPosition = event.layerX + 67;
                this.leftPosition = event.layerX;
                this.topPosition = event.layerY;
                this.isUpdate = false;

                this.comment = {
                    id: null,
                    offsetXPercentage: event.layerX,
                    offsetYPercentage: event.layerY,
                    containerHeight: window.innerHeight,
                    containerWidth: window.innerWidth,
                    containerOffsetX: event.offsetX,
                    containerOffsetY: event.offsetY,
                    pinX: event.layerX,
                    pinY: event.layerY,
                    comment: null
                };
                this.showPostFrm = true;

            }
        },
        closePostFrm() {
            this.comment = {
                id: null,
                offsetXPercentage: null,
                offsetYPercentage: null,
                containerHeight: null,
                containerWidth: null,
                containerOffsetX: null,
                containerOffsetY: null,
                pinX: null,
                pinY: null,
                comment: null
            };
            this.showPostFrm = false;
            this.leftPosition = null;
            this.topPosition = null;
        },
        getImagePath(){
            let url = window.route('medias.view', {
                path: 'so_attachments',
                id: this.order.id,
                name: src
            });

            return url;
        },
        handleDocumentRender() {
            this.isLoading = false
        },
        handlePasswordRequest(callback, retry) {
            callback(prompt(retry
                ? 'Enter password again'
                : 'Enter password'
            ))
        },
        getComments() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('artworks.get.comments', {id: this.order.id, artwork_id: this.artwork.id}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                       this.comments = data.data;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        save() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('artworks.add.comments', {id: this.order.id, artwork_id: this.artwork.id}), this.comment, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        this.$emit('commentAdded', {id: this.order.id, artwork_id: this.artwork.id});
                        this.closePostFrm();
                        this.comments.push(data.data);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        deleteComment(index, id) {
            if(id) {
                let self = this;
                this.setLoading(true);
                this.setCommonErrors([]);
                this.setErrorMessage(null);
                return axios.delete(window.route('artworks.del.comments', {id: this.order.id, comment_id: id}), {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                    .then(({data}) => {
                        if (data.errorMessage) {
                            self.setErrorMessage(data.errorMessage);
                            if (data.errors) {
                                self.setCommonErrors(data.errors);
                            }
                        } else {
                            //this.comments.splice(index, 1);
                            this.getComments();
                        }
                    })
                    .catch((error) => {
                        self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                    })
                    .finally(() => {
                        self.setLoading(false);

                    });
            } else {
                this.comments.splice(index, 1);
            }
        },
        getQuillToolbar() {
            return [
                ['bold', 'italic', 'underline', 'strike'],
                [{
                    'list': 'ordered'
                }, {
                    'list': 'bullet'
                }],
            ]
        },
        imageLoaded(){
            this.imageLoading = false;
        },
        imageFailed(){
            this.imageLoadFailed = true;
            this.imageLoading = false;
        },
        pdfLoadFailed() {
            this.pdfLoadingFailed = true;
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading',
        ])
    },
    watch: {
        artwork: {
            handler: function (after, before) {
                this.comments = [];
                if(after != null) {
                    this.getComments();
                }

            },
            deep: true,
        },
    }
}
</script>

<style scoped>
.canvas-column {
    -webkit-transition: padding-right .5s ease,-webkit-transform .5s ease;
    transition: padding-right .5s ease,-webkit-transform .5s ease;
    transition: transform .5s ease,padding-right .5s ease;
    transition: transform .5s ease,padding-right .5s ease,-webkit-transform .5s ease;
}

.project-canvas-container {
    height: 100%;
    position: relative;
}

.project-canvas-container .project-canvas-scroll-container {
    height: 100%;
    overflow: scroll;
    position: relative;
}
.project-canvas-container .project-canvas-scroll-container .project-canvas {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    height: 100%;
    justify-content: center;
}
.image-canvas-container {
    height: 100%;
}
.image-canvas {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
}
.image-canvas .image-wrapper {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    overflow: hidden;
    position: relative;
    width: 100%;
}
.image-canvas .image-wrapper.fit-horizontally .image-scroll-container {
    overflow-x: hidden;
}
.image-canvas .image-scroll-container > div {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    justify-content: center;
    min-height: 100%;
    min-width: 100%;
    position: relative;
}
.image-canvas .image-scroll-container > div > div {
    margin: 0 auto;
    position: relative;
}
.image-canvas .image-scroll-container {
    height: 100%;
    overflow: scroll;
    overflow-x: scroll;
    position: relative;
    width: 100%;
}
.image-canvas .image-scroll-container > div > div > img {
    height: 100%;
    width: 100%;
}

.threadPin:not(.no-hover), .threadPin:not(.no-hover) .markupThreadPinContent {
    cursor: pointer !important;
}

.threadPin {
    clip: auto !important;
    grid-column-gap: normal !important;
    -webkit-font-feature-settings: normal !important;
    font-feature-settings: normal !important;
    all: initial !important;
    -webkit-animation: none 0s ease 0s 1 normal none running !important;
    animation: none 0s ease 0s 1 normal none running !important;
    -webkit-backface-visibility: visible !important;
    backface-visibility: visible !important;
    background: transparent none repeat 0 0/auto auto padding-box border-box scroll !important;
    background: #2590e2 !important;
    border: 2px solid #fff !important;
    border-image-outset: 0;
    border-image-repeat: stretch;
    border-image-slice: 100%;
    border-image-source: none;
    border-image-width: 1;
    border-collapse: separate !important;
    -o-border-image: none !important;
    border-image: none !important;
    border-radius: 0 !important;
    border-radius: 15px !important;
    border-spacing: 0 !important;
    bottom: auto !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    -webkit-box-shadow: 0 5px 10px rgba(0,0,0,.15) !important;
    box-shadow: 0 5px 10px rgba(0,0,0,.15) !important;
    -webkit-box-sizing: content-box !important;
    box-sizing: content-box !important;
    -webkit-box-sizing: border-box !important;
    box-sizing: border-box !important;
    caption-side: top !important;
    clear: none !important;
    color: #000 !important;
    color: #fff !important;
    -webkit-column-fill: balance !important;
    -moz-column-fill: balance !important;
    column-fill: balance !important;
    -webkit-column-gap: normal !important;
    -moz-column-gap: normal !important;
    column-gap: normal !important;
    -webkit-column-rule: medium none currentColor !important;
    -moz-column-rule: medium none currentColor !important;
    column-rule: medium none currentColor !important;
    -webkit-column-span: 1 !important;
    -moz-column-span: 1 !important;
    -webkit-columns: auto !important;
    -moz-columns: auto !important;
    -webkit-column-count: auto !important;
    -moz-column-count: auto !important;
    column-span: 1 !important;
    -webkit-column-width: auto !important;
    -moz-column-width: auto !important;
    columns: auto !important;
    content: normal !important;
    counter-increment: none !important;
    counter-reset: none !important;
    cursor: auto !important;
    cursor: pointer !important;
    direction: ltr !important;
    display: inline !important;
    display: block !important;
    empty-cells: show !important;
    float: none !important;
    /*font-family: serif !important;*/
    font-size: medium !important;
    font-size: 14px !important;
    font-stretch: normal !important;
    font-style: normal !important;
    font-variant: normal !important;
    font-weight: 400 !important;
    font-weight: 600 !important;
    height: auto !important;
    height: 30px !important;
    -webkit-hyphens: none !important;
    -ms-hyphens: none !important;
    hyphens: none !important;
    left: auto !important;
    letter-spacing: normal !important;
    line-height: normal !important;
    line-height: 26px !important;
    list-style: disc none outside !important;
    margin: 0 !important;
    max-height: none !important;
    max-width: none !important;
    min-height: 0 !important;
    min-width: 0 !important;
    min-width: 30px !important;
    opacity: 1 !important;
    orphans: 2 !important;
    outline: medium none invert !important;
    outline: none;
    overflow: visible !important;
    overflow-x: visible !important;
    overflow-y: visible !important;
    padding: 0 !important;
    page-break-after: auto !important;
    page-break-before: auto !important;
    page-break-inside: auto !important;
    -webkit-perspective: none !important;
    perspective: none !important;
    -webkit-perspective-origin: 50% 50% !important;
    perspective-origin: 50% 50% !important;
    position: static !important;
    position: absolute !important;
    right: auto !important;
    -moz-tab-size: 8 !important;
    -o-tab-size: 8 !important;
    tab-size: 8 !important;
    table-layout: auto !important;
    text-align: left !important;
    text-align: center !important;
    -moz-text-align-last: auto !important;
    text-align-last: auto !important;
    text-decoration: none !important;
    text-indent: 0 !important;
    text-shadow: none !important;
    text-transform: none !important;
    top: auto !important;
    -webkit-transform: none !important;
    transform: none !important;
    -webkit-transform-origin: 50% 50% 0 !important;
    transform-origin: 50% 50% 0 !important;
    -webkit-transform-style: flat !important;
    transform-style: flat !important;
    -webkit-transition: none 0s ease 0s !important;
    transition: none 0s ease 0s !important;
    -webkit-transition: background .25s !important;
    transition: background .25s !important;
    unicode-bidi: normal !important;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    vertical-align: baseline !important;
    visibility: visible !important;
    white-space: normal !important;
    widows: 2 !important;
    width: auto !important;
    width: -webkit-max-content !important;
    width: -moz-max-content !important;
    width: max-content !important;
    word-spacing: normal !important;
    z-index: auto !important;
}


.image-project-click-shield {
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
}

.thread-list-top-nav {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-box-pack: space-evenly;
    -ms-flex-pack: space-evenly;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    height: 120px;
    justify-content: space-evenly;
}
.thread-list {
    max-height: calc(100% - 120px);
    overflow-y: auto;
}


.thread-list::after {

    background: transparent -webkit-gradient(linear,left bottom,left top,from(hsla(0,0%,100%,0)),to(rgba(0,0,0,.051))) 0 0 no-repeat padding-box;
    background: transparent linear-gradient(1turn,hsla(0,0%,100%,0),rgba(0,0,0,.051)) 0 0 no-repeat padding-box;
    content: "";
    height: calc(100% - 120px);
    left: 0;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 120px;
    -webkit-transition: opacity .3s ease-in-out;
    transition: opacity .3s ease-in-out;
    width: 100%;

}

.thread-list .thread-list-group .thread-list-item-group-header {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    cursor: pointer;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    margin: 18px 23px;
    padding: 0;
    position: relative;
    text-align: left;
}

.thread-list .thread-list-item-container {
    -webkit-transition-duration: .3s;
    transition-duration: .3s;
    -webkit-transition-property: height,-webkit-transform;
    transition-property: height,-webkit-transform;
    transition-property: transform,height;
    transition-property: transform,height,-webkit-transform;
    -webkit-transition-timing-function: cubic-bezier(.47,0,.745,.715);
    transition-timing-function: cubic-bezier(.47,0,.745,.715);
}

.thread-list .thread-list-item-container .thread-list-item-content {
    border: 1px solid #eaeaea;
    border-radius: 10px;
    -webkit-box-shadow: 2px 2px 0 rgba(0,0,0,.059);
    box-shadow: 2px 2px 0 rgba(0,0,0,.059);
    margin: 0 0px 18px;
}

.thread-list .thread-list-item {
    display: grid;
    grid-template-columns: minmax(0,1fr) 57px;
    min-height: 50px;
    position: relative;
}

.thread-list .thread-list-item .thread-list-item-message-column {
    grid-column-end: 3;
    grid-column-start: 1;
    padding: 12px 12px 0;
}

.thread-list .thread-list-item .thread-list-item-message-column .thread-list-item-message-column-header {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    position: relative;
}

.thread-list .thread-list-item .thread-list-item-message-column .thread-list-item-message-column-header .message-author {
    color: #333;
    font-size: 13px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.thread-list .thread-list-item .thread-list-item-message-column .message-time {
    color: #999;
    font-size: 13px;
    font-weight: 400;
    margin-top: 5px;
}

.thread-list .thread-list-item .thread-list-item-message-column .message {
    display: block;
    font-weight: 400;
    -ms-hyphens: auto;
    -webkit-hyphens: auto;
    hyphens: auto;
    margin-top: 5px;
    white-space: pre-wrap;
}


.thread-list .thread-list-item .thread-list-item-message-column .ql-snow.message .ql-editor {
    overflow: visible;
    padding: 0;
}

.thread-list .thread-list-item .thread-list-item-message-column .ql-snow .ql-editor p {
    word-wrap: break-word;
    -ms-word-break: break-all;
    word-break: break-all;
    word-break: break-word;
}

.thread-list .thread-list-item .message .ql-editor > * {
    cursor: pointer;
}

.badge {
    background-color: #fe4c41;
    border-radius: 8px;
    color: #fff;
    font-size: 10px;
    left: -13px;
    line-height: 13px;
    padding: 2px 10px;
    position: absolute;
}

.thread-list .thread-list-item .message-badge, .thread-list .thread-list-item .thread-list-item-badge {
    left: 6px;
    position: relative;
    top: 0;
    -webkit-transition: opacity 2s ease;
    transition: opacity 2s ease;
}

.thread-list .thread-list-item .thread-label {
    background: #2590e2;
    border: 2px solid #fff;
    border-radius: 15px;
    -webkit-box-shadow: 0 5px 10px rgba(0,0,0,.15);
    box-shadow: 0 5px 10px rgba(0,0,0,.15);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #fff;
    cursor: pointer;
    display: block;
    /*font-family: AvenirNext LT Pro,Arial,Helvetica,sans-serif;*/
    font-size: 14px;
    font-weight: 600;
    height: 30px;
    line-height: 26px;
    min-width: 30px;
    outline: none;
    padding-left: 6px;
    padding-right: 6px;
    position: absolute;
    right: 10px;
    text-align: center;
    top: 10px;
    -webkit-transition: background .25s;
    transition: background .25s;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: -webkit-max-content;
    width: -moz-max-content;
    width: max-content;
}

.thread-list .thread-list-item .thread-list-item-notes.empty {
    border-top: none;
}

.thread-list .thread-list-item .thread-list-item-notes {
    border-top: 1px solid #eaeaea;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    grid-column: 1/3;
    margin: 5px 12px 0;
    padding: 4px 0;
}
.threadfooter{
    padding:5px 12px;
}
.threadfooter .trashBtn{
    color: #f2385a;
}

.image-project-click-shield.has-pending-thread {
    pointer-events: auto;
}

.image-project-click-shield {
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
}
.canvas-pending-thread-form .form {
    pointer-events: none;
    z-index: 1002;
}

.canvas-pending-thread-form .form .form-contents.top {
    /*-webkit-transform: translate(-50%,calc(-100% - 30px));
    transform: translate(-50%,calc(-100% - 30px));*/
}

.canvas-pending-thread-form .form .form-contents {
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 10px;
    -webkit-box-shadow: 1px 1px rgba(0,0,0,.5);
    box-shadow: 1px 1px rgba(0,0,0,.5);
    pointer-events: auto;
    position: relative;
    width: 330px;
}

.canvas-pending-thread-form .form .form-contents.top::before {
    border: 14px solid transparent;
    border-top-color: transparent;
    border-bottom-color: transparent;
    border-bottom-style: solid;
    border-bottom-width: 14px;
    border-bottom: 0;
    border-top-color: rgba(0,0,0,.5);
    bottom: 0;
    content: "";
    height: 0;
    left: 50%;
    margin-bottom: -15px;
    margin-left: -14px;
    position: absolute;
    width: 0;
}

.canvas-pending-thread-form .pin {
    background: #1b00fb;
    border: 2px solid #fff;
    border-radius: 50%;
    height: 24px;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    width: 24px;
    z-index: 1001;
}

.canvas-pending-thread-form .form .form-contents {
    pointer-events: auto;
}

.canvas-pending-thread-form .form .form-contents .close-button {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: #999;
    border-radius: 8px;
    color: #fff;
    cursor: pointer;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    font-size: .75rem;
    height: 16px;
    justify-content: center;
    position: absolute;
    right: 7px;
    top: 7px;
    width: 16px;
    z-index: 10000;
}

.message-form-buttons {
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 54px;
    justify-content: flex-end;
}

.canvas-pending-thread-form .form .form-contents .message-form-buttons {
    margin-right: 9.5px;
}

.post-button {
    background-color: #2590e2;
    border: none;
    border-radius: 8px;
    color: #fff;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    height: 35px;
    margin-right: 5px;
    min-height: 40px;
    outline: none;
    padding: 0 16px;
    width: 70px;
}


.canvas-pending-thread-form .form .form-contents .markup-quill-editor .ql-toolbar.ql-snow {
    border: none;
}

.ql-toolbar.ql-snow {
    border: 1px solid #ccc;
    box-sizing: border-box;
    font-family: Helvetica Neue,Helvetica,Arial,sans-serif;
    padding: 8px;
}

.ql-snow .ql-formats {
    display: inline-block;
    vertical-align: middle;
}

.ql-toolbar.ql-snow .ql-formats {
    margin-right: 15px;
}

.ql-snow .ql-toolbar::after, .ql-snow.ql-toolbar::after {
    clear: both;
    content: "";
    display: table;
}

.canvas-pending-thread-form .form .form-contents .markup-quill-editor .ql-toolbar.ql-snow + .ql-container.ql-snow {
    border: 1px solid #ccc;
    border-right-color: rgb(204, 204, 204);
    border-right-style: solid;
    border-right-width: 1px;
    border-left-color: rgb(204, 204, 204);
    border-left-style: solid;
    border-left-width: 1px;
    border-left: none;
    border-right: none;
}
.canvas-pending-thread-form .form .form-contents .markup-quill-editor .ql-container {
    height: 108px;
}

.ql-editor {
    word-wrap: break-word;
    box-sizing: border-box;
    height: 100%;
    line-height: 1.42;
    outline: none;
    overflow-y: auto;
    padding: 12px 15px;
    -o-tab-size: 4;
    tab-size: 4;
    -moz-tab-size: 4;
    text-align: left;
    white-space: pre-wrap;
    min-height: inherit;
}
.thread-list .ql-editor{
    min-height: inherit;
}
ol{
    padding-left: 20px;
}
ul{
    padding-left: 20px;
}
p{
    margin-bottom: 10px;
}

</style>
